export const randomColor = () => ('#' + (Math.random() * 0xFFFFFF << 0).toString(16) + '000000').slice(0, 7);

const FNV_PRIME = 16777619;
const FNV_OFFSET_BASIS = 2166136261;

export function generateColor(name) {
    // FNV-1a hash for good bit distribution
    let hash = FNV_OFFSET_BASIS;
    for (let i = 0; i < name.length; i++) {
        hash ^= name.charCodeAt(i);
        hash = Math.imul(hash, FNV_PRIME);
    }

    // Convert 32-bit unsigned to float in [0,1)
    const normalized = (hash >>> 0) / 0xffffffff;
    const hue = Math.floor(normalized * 360); // hue
    const saturation = 20 + normalized * 50; // 20 to 70
    const lightness = 40 + normalized * 10; // 45 to 55
    const background = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

    return background;
}
